import { Button } from '@unified-checkout/design-system';
import {
  ChevronLeft,
  Xmark,
} from '@unified-checkout/design-system/icons/index';

type MobileModalProps = {
  title?: string;
  text?: string;
  onCancel: () => void;
  children: React.ReactNode;
  hasBackButton?: boolean;
  hasCloseButton?: boolean;
  isModal?: boolean;
};
export const MobileModal = ({
  title,
  text,
  onCancel,
  children,
  hasBackButton,
  hasCloseButton,
  isModal,
}: MobileModalProps) => {
  return (
    <div className="fixed cursor-pointer inset-0 bg-[#0002] backdrop-blur-sm z-10 flex items-end whitespace-pre-line">
      <div className={`flex relative flex-col p-4 w-full bg-white rounded-3xl space-y-5 ${isModal ? 'h-auto' : 'h-[75%]'}`}>
        {hasBackButton && (
          <Button
            color="secondary"
            variant="outlined"
            onClickHandler={onCancel}
            leadingIcon={ChevronLeft}
          />
        )}
          {hasCloseButton && (
        <div className="ms-auto p-0 [&>button]:!p-0">
            <Button
              color="secondary"
              variant="link"
              onClickHandler={onCancel}
              leadingIcon={Xmark}
              size="2xl"
            />
        </div>
          )}
        {(title || text) && (
          <section>
            {title && (
              <h2 className="text-gray-900 english-heading-h6-semibold">
                {title}
              </h2>
            )}
            {text && (
              <p className="text-gray-600 english-body-md-regular">{text}</p>
            )}
          </section>
        )}
        {children}
      </div>
    </div>
  );
};
